<!--suppress ALL -->
<template>
  <div class="g-tab">
    <div :class="className">
      <ul :class="tabUlClass">
        <li v-for="(link, index) in links" :key="`tab-item-${index}`" :class="liActive(link.to, index)">
          <g-link v-if="useAsLink" :to="link.to">
            <div v-if="$scopedSlots['tab-item'] || $slots['tab-item']" class="wrapper-c">
              <slot name="tab-item" :link="link" :index="index"></slot>
            </div>
            <template v-else-if="link.icon">
              <span class="icon"><i :class="link.icon"></i></span>
              <span>{{link.name}}</span>
            </template>
            <span v-else>{{link.name}}</span>
          </g-link>
          <a v-else @click="onMoveTab(index)">
            <div v-if="$scopedSlots['tab-item'] || $slots['tab-item']" class="wrapper-c">
              <slot name="tab-item" :link="link" :index="index"></slot>
            </div>
            <template v-else-if="link.icon">
              <span class="icon"><i :class="link.icon"></i></span>
              <span>{{link.name}}</span>
            </template>
            <span v-else>{{link.name}}</span>
          </a>
        </li>
        <slot name="suffixTab"></slot>
      </ul>
      <slot name="customTab"></slot>
    </div>
    <div class="tab-content" :class="tabContentClass" ref="tabContent">
      <slot :index="currentTab"></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Mixin} from 'annotation';
  import GLink from '../link/GLink.vue';
  import QueryString from '../../../../util/mixin/QueryString';

  @Component({
    components: {GLink}
  })
  export default class GTab extends Mixin(QueryString) {

    @Prop({default: []})
    public links: Array<any>;

    @Prop({default: '', type: String})
    public position: string;

    @Prop({default: '', type: String})
    public size: string;

    @Prop({default: false, type: Boolean})
    public isToggle: boolean;

    @Prop({default: false, type: Boolean})
    public isFullWidth: boolean;

    @Prop({default: false, type: Boolean})
    public isBoxed: boolean;

    @Prop({default: '', type: String})
    public tabContentClass: string;

    @Prop({default: '', type: String})
    public tabUlClass: string;

    @Prop({default: '', type: String})
    public tabsClass: string;

    @Prop({defaut: 0})
    public currentTab: number;

    // if you want to remounted the components
    // every move tab. so you can refetching
    // the resources
    @Prop({defaut: false, type: Boolean})
    public implementHiddenItSelf: boolean;

    public tempTab: number = 0;

    public get useAsLink() {
      if (this.links.length) {
        return this.links[0].to ? true : false;
      }

      return false;
    }

    public get className() {
      const {position, size, isBoxed, isToggle, isFullWidth, tabsClass} = this;
      const positionClassName = position ? ('is-' + position) : '';
      const sizeClassName = size ? ('is-' + size) : '';
      const classNames = [positionClassName, sizeClassName].reduce((accu, item) =>
        accu + (item ? (item + ' ') : ''), 'tabs ');

      return [classNames, tabsClass, {
        'is-toggle': isToggle, 'is-boxed': isBoxed,
        'is-fullwidth': isFullWidth
      }];
    }

    public mounted() {
      // const currentIndex = this.links.findIndex(link => this.matchAbsoluteUrl(link.to)) || 0;
      // this.hideSomeTab(this.useAsLink ? currentIndex : 0);

      if (this.hasVueRouter && this.useAsLink) {
        this.$watch('$route', () => {
          const currentIndex = this.links.findIndex(link => this.matchAbsoluteUrl(link.to)) || 0;

          this.$emit('change', currentIndex);
          this.hideSomeTab(currentIndex);
        }, {immediate: true});
      }
    }

    public liActive(to, index) {
      const {useAsLink, currentTab, tempTab} = this;
      const isCurrentTab = typeof currentTab === 'number' ? (currentTab === index) : (tempTab === index);

      return useAsLink ? this.matchAbsoluteUrl(to) : isCurrentTab ? 'is-active' : '';
    }

    public onMoveTab(index, skipEmit: boolean = false) {
      this.tempTab = index;

      if (!skipEmit) {
        this.$emit('update:currentTab', index);
        this.$emit('change', index);
      }

      if (!this.hasVueRouter || !this.useAsLink) {
        this.hideSomeTab(index);
      }
    }

    public hideSomeTab(index) {
      if (!this.implementHiddenItSelf) {
        Array.from(this.$refs.tabContent && this.$refs.tabContent.children).forEach((item, idxChild) => {
          if (item instanceof HTMLElement) {
            if (idxChild === index) {
              item.classList.remove('is-hidden');
            } else {
              item.classList.add('is-hidden');
            }
          }
        });
      }
    }
  }
</script>
